import * as basicLightbox from 'basiclightbox'

export function lightboxInit() {	

	const galleryImages = document.querySelectorAll('.flagship-gallery__image img');

	if ( galleryImages ) {
		for ( let galleryImage of galleryImages ) {
			galleryImage.addEventListener('click', function(e) {								
				e.preventDefault();
				
				let datasrc = this.getAttribute('data-lightbox');							

				console.log(datasrc);

				basicLightbox.create(`
					<img src="` + datasrc + `" alt="Fullscreen image">
				`).show();			
			});			
		}
	}
}